import type { ReactNode } from "react";

import React from "react";
import {
  CheckCircle,
  ExclamationCircle,
  InfoCircle,
  XCircle,
} from "react-bootstrap-icons";

import Notification from ".";

export interface IGlobalNotificationProps {
  type: "success" | "danger" | "warning" | "info";
  message: ReactNode;
  closeToast: () => void;
  customIcon?: ReactNode;
}

interface NotificationConfig {
  bg: string;
  Icon: ReactNode;
  textClassName?: string;
}

function GlobalNotification({
  type,
  message,
  closeToast,
  customIcon,
}: IGlobalNotificationProps) {
  const configs: Record<IGlobalNotificationProps["type"], NotificationConfig> =
    {
      success: {
        bg: "body-color",
        Icon: <CheckCircle size={18} className="text-success" />,
      },
      danger: {
        bg: "danger-subtle",
        Icon: <XCircle size={18} className="text-danger" />,
        textClassName: "text-danger",
      },
      warning: {
        bg: "warning-subtle",
        Icon: <ExclamationCircle size={18} className="text-warning" />,
        textClassName: "text-warning",
      },
      info: {
        bg: "info-subtle",
        Icon: <InfoCircle size={18} className="text-info" />,
        textClassName: "text-info",
      },
    };

  const { bg, Icon: DefaultIcon, textClassName } = configs[type];

  return (
    <Notification
      message={message}
      onClose={closeToast}
      bg={bg}
      Icon={customIcon ?? DefaultIcon}
      textClassName={textClassName}
    />
  );
}

export default GlobalNotification;
